import React, { useState } from 'react';
import { IAreaByFigure, ISeat, ISeatDetails, ISeatState, IWorkStation } from 'types/shared';
import WorkStation from './workStation';
import SeatInfoPopOver from './seatInfoPopOver/seatInfoPopOver';

interface CanvasProps {
	seatStatesList: ISeatState[];
	workStations: IWorkStation[];
	selectedSeat?: ISeat;
	employeeProject?: string;
	onSelectSeat?: (seat: ISeat) => void;
}

const Canvas: React.FC<CanvasProps> = ({
	seatStatesList,
	workStations,
	selectedSeat,
	onSelectSeat,
	employeeProject,
}) => {
	const [anchorEl, setAnchorEl] = useState<null | SVGRectElement>(null);
	const [hoveredSeat, setHoveredSeat] = useState<ISeat | null>(null);

	const showSeatInfo = (
		event: React.MouseEvent<SVGRectElement>,
		seat: ISeat
	) => {
		if (seatStatesList[seat.seatStateId -1].name !== 'Available') {
			setHoveredSeat(seat);
			setAnchorEl(event.currentTarget);
		}
	};
	const hideSeatInfo = () => {
		setHoveredSeat(null);
		setAnchorEl(null);
	};

	return (
		<>
			<svg viewBox="0 0 1000 1000">
				{workStations.map((workstation) => (
					<WorkStation
						key={`WorkStation ${workstation.id}`}
						workStation={workstation}
						selectedSeat={selectedSeat}
						onSelectSeat={onSelectSeat}
						showSeatInfo={showSeatInfo}
						hideSeatInfo={hideSeatInfo}
						seatStatesList={seatStatesList}
					/>
				))}
				{/* {figures?.map((figure) => (
				<Figure
					key={`Figure ${figure.id}`}
					type={figure.figureName}
					x={figure.}
					y={figure.y}
					width={figure.width}
					height={figure.height}
					rotation={figure.rotation}
					text={figure.text}
				/>
			))} */}
			</svg>
			<SeatInfoPopOver
				anchorEl={anchorEl}
				seat={hoveredSeat}
				onClose={hideSeatInfo}
				employeeProject={employeeProject}
			/>
		</>
	);
};

export default Canvas;
